export default __webpack_public_path__ + "static/media/extra_out_d9.b83fd21b.svg";